import React, { useEffect, useRef } from "react";
import { useConsultContext, useDoctorContext } from "../contexts";
import {
	ConsultTable,
	TelehealthDashboard
} from "../components/TelehealthQueue";

export const TelehealthQueue = React.memo(() => {
	const { consults, completedConsultsCount, setRefreshConsults } =
		useConsultContext();
	const { activeTelehealthDoctors } = useDoctorContext();
	const consultIntervalId = useRef(0);

	useEffect(() => {
		consultIntervalId.current = setInterval(() => {
			console.info("TelehealthQueue setRefreshConsults");
			setRefreshConsults(true);
		}, 60000) as unknown as number;

		return () => {
			clearInterval(consultIntervalId.current);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="flex flex-col gap-6">
			<div className="ch-l-text mt-4">Telehealth Queue</div>
			<TelehealthDashboard
				consultCount={consults.length}
				doctorCount={activeTelehealthDoctors?.length || 0}
				completedCounsultCount={completedConsultsCount}
			/>
			<ConsultTable />
		</div>
	);
});
